export default __webpack_public_path__ + "static/media/_dkg_kopf-hals_rgb.76b860e4.svg";